<script lang="ts">
  let { label, checked = $bindable(), testid }: { label: string; checked: boolean; testid?: string } = $props();
</script>

<label class="toggle">
  <input type="checkbox" bind:checked data-testid={testid} />
  <span>{label}</span>
</label>

<style>
  .toggle {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
  }
</style>
